import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const MergeTimeoutErrorFromLibrary = BaseErrorSchema.extend({
  errorType: z.literal('MergeTimeoutErrorFromLibrary'),
  mergeMessage: z.string().optional(),
});

export type MergeTimeoutErrorFromLibrary = z.infer<
  typeof MergeTimeoutErrorFromLibrary
>;

export const isMergeTimeoutErrorFromLibrary = (
  error: Record<string, unknown>,
): error is MergeTimeoutErrorFromLibrary => {
  return (
    error.errorType === 'MergeTimeoutErrorFromLibrary' &&
    (error.mergeMessage === undefined || typeof error.mergeMessage === 'string')
  );
};

export const MergeFetchFailedErrorFromLibrary = BaseErrorSchema.extend({
  errorType: z.literal('MergeFetchFailedErrorFromLibrary'),
  mergeMessage: z.string().optional(),
  mergeStatusCode: z.number().optional(),
  mergeBody: z.unknown().optional(),
});

export type MergeFetchFailedErrorFromLibrary = z.infer<
  typeof MergeFetchFailedErrorFromLibrary
>;

export const isMergeFetchFailedErrorFromLibrary = (
  error: Record<string, unknown>,
): error is MergeFetchFailedErrorFromLibrary => {
  return (
    error.errorType === 'MergeFetchFailedErrorFromLibrary' &&
    (typeof error.mergeMessage === 'string' ||
      error.mergeMessage === undefined) &&
    (typeof error.mergeStatusCode === 'number' ||
      error.mergeStatusCode === undefined)
  );
};

export const MergeGenericErrorFromLibrary = BaseErrorSchema.extend({
  errorType: z.literal('MergeGenericErrorFromLibrary'),
  mergeMessage: z.string().optional(),
  mergeStatusCode: z.number().optional(),
  mergeBody: z.unknown().optional(),
});

export type MergeGenericErrorFromLibrary = z.infer<
  typeof MergeGenericErrorFromLibrary
>;

export const isMergeGenericErrorFromLibrary = (
  error: Record<string, unknown>,
): error is MergeGenericErrorFromLibrary => {
  return (
    error.errorType === 'MergeGenericErrorFromLibrary' &&
    (error.mergeMessage === undefined ||
      typeof error.mergeMessage === 'string') &&
    (error.mergeStatusCode === undefined ||
      typeof error.mergeStatusCode === 'number')
  );
};

export const MergeErrorFromLibrary = z.union([
  MergeTimeoutErrorFromLibrary,
  MergeFetchFailedErrorFromLibrary,
  MergeGenericErrorFromLibrary,
]);

export type MergeErrorFromLibrary = z.infer<typeof MergeErrorFromLibrary>;
